import axios from 'axios';

// const API_URL = 'http://localhost:8000/accounts/';  // 백엔드 API URL

const apiUrl = process.env.REACT_APP_API_URL;  // 환경 변수로 API URL 불러오기

const authService = {
  // 로그인 함수
  login: async (loginId, password) => {
    try {
      const response = await axios.post(apiUrl + '/login/', { login_id: loginId, password });
      if (response.data.access) {
        localStorage.setItem('accessToken', response.data.access);
        localStorage.setItem('refreshToken', response.data.refresh);
        return true;
      }
    } catch (error) {
      console.error('Login error:', error.response?.data || error.message);
      return false;
    }
  },

  // 로그아웃 함수
  logout: () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
  },

  // 보호된 데이터 요청 함수
  fetchProtectedData: async () => {
    const token = localStorage.getItem('accessToken');
    if (!token) throw new Error('로그인된 사용자가 아닙니다.');

    const response = await axios.get(apiUrl + 'protected-endpoint/', {
      headers: { Authorization: `Bearer ${token}` },
    });

    return response.data;
  },

  // 토큰 검증 함수
  isAuthenticated: async () => {
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('refreshToken');

    if (!accessToken) return false;

    try {
      // 액세스 토큰 검증 시도
      await axios.post(apiUrl + '/token/verify/', { token: accessToken });
      return true;

    } catch (error) {
      // 액세스 토큰이 만료된 경우
      if (error.response && error.response.status === 401 && refreshToken) {
        try {
          const refreshResponse = await axios.post(apiUrl + 'token/refresh/', { refresh: refreshToken });
          const newAccessToken = refreshResponse.data.access;
          localStorage.setItem('accessToken', newAccessToken);
          return true;
        } catch (refreshError) {
          console.error('토큰 갱신 실패:', refreshError);
          return false;
        }
      }

      console.error('Token validation failed:', error.response?.data || error.message);
      return false;
    }
  },

  // 인증 헤더 생성 함수
  getAuthHeader: () => {
    const token = localStorage.getItem('accessToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
  }
};

export default authService;
